<template>
  <div class="setTing">
    <div class="title text-no">
      <div class="flex1">
        <div
          class="tabs"
          :class="setTingIndex == 1 ? 'tabBorder' : ''"
          @click="cutover(1)"
        >
          账单模板
        </div>
        <!-- <div
          class="tabs"
          :class="setTingIndex == 2 ? 'tabwBorder' : ''"
          @click="cutover(2)"
        >
          发票设置
        </div>-->
        <div
          class="tabs"
          :class="setTingIndex == 3 ? 'tabBorder' : ''"
          @click="cutover(3)"
        > 
          额度
        </div>
        <div
          class="tabs"
          :class="setTingIndex == 4 ? 'tabBorder' : ''"
          @click="cutover(4)"
        >
          合同
        </div>
        <div
          class="tabs"
          :class="setTingIndex == 5 ? 'tabBorder' : ''"
          @click="cutover(5)"
        >
          用户管理
        </div>
        <div
          class="tabs"
          style="max-width: 100px"
          :class="setTingIndex == 6 ? 'tabBorder' : ''"
          @click="cutover(6)"
        >
          客户账号管理
        </div>
      </div>
    </div>
    <div class="main">
      <download v-if="setTingIndex == 1"></download>
      <!-- <setUp v-if="setTingIndex == 2"></setUp> -->
      <!-- <maintain v-if="setTingIndex == 3"></maintain> -->
      <limits v-if="setTingIndex == 3"></limits>
      <contract v-if=" setTingIndex == 4"></contract>
      <accountManager v-if="setTingIndex == 5"></accountManager>
      <customerPaymentManager v-if="setTingIndex == 6"></customerPaymentManager>
    </div>
  </div>
</template>

<script>
import download from "./component/download.vue";
// import setUp from "./component/setUp.vue";
// import maintain from "./component/maintain.vue";
import accountManager from "./component/accountManager.vue";
import customerPaymentManager from "./component/customerPaymentManager.vue";
import limits from './component/limits.vue'
import contract from './component/contract.vue'
import { paths } from '../../utils/pathNew.js'
import { mapState } from "vuex";

export default {
  data() {
    return {
      // tab: 3,
    };
  },
  components: {
    download,
    limits,
    contract,
    accountManager,
    customerPaymentManager,
  },
  computed: {
    ...mapState({
      setTingIndex: function (state) {
        return state.setTingIndex;
      },
    }),
  },
  methods: {
    cutover(i) {
      if (i == this.tab) return;
      // this.tab = i;
      this.$store.commit("setTingIndex", i);
      window.localStorage.setItem("setTingIndex", i);
      window.sessionStorage.setItem("setTingIndex", i);
    },
  },
  
  created(){
        // Tab 导航栏 样式跟随
    let url = window.location.hash;
    this.$store.commit("urlIndex", paths(url));
  }
};
</script>

<style lang='less'>
.setTing {
  font-family: 'Avenir', 'Helvetica', 'Arial', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: auto;
  background-color: #f7f7f8ff;
  .title {
    display: flex;
    height: 46px;
    line-height: 44px;
    box-shadow: 0px 9px 20px 0px rgba(102, 139, 204, 0.04);
    background-color: #fff;
    border: 1px solid #ececec;
    .flex1 {
      flex: 2;
      display: flex;
      justify-content: center;
      cursor: pointer;
      .tabs {
        margin: 0 25px;
        max-width: 64px;
        flex: 1;
        &:hover {
          color: #008cffff;
          border-bottom: 2px solid #008cffff;
          max-width: 64px;
        }
      }
    }
  }
  .main {
    flex: 1;
    margin: 16px 24px;
    background-color: #fff;
    border-radius: 4px;
    overflow: auto;
    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-track {
      background-color: rgba(0, 1, 0, 0);
    }
    &::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.2);
      -webkit-border-radius: 8px;
      -moz-border-radius: 8px;
      border-radius: 8px;
    }
  }
}
.tabBorder {
  //color: #000;
  border-bottom: 2px solid #008cffff;
  max-width: 64px;
  color:#008cffff ;
}
</style>